import { render, staticRenderFns } from "./StartTest.vue?vue&type=template&id=413aa34a&scoped=true&"
import script from "./StartTest.vue?vue&type=script&lang=js&"
export * from "./StartTest.vue?vue&type=script&lang=js&"
import style0 from "./StartTest.vue?vue&type=style&index=0&id=413aa34a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413aa34a",
  null
  
)

export default component.exports